import { render, staticRenderFns } from "./messageList.vue?vue&type=template&id=33a32f53&scoped=true&"
import script from "./messageList.vue?vue&type=script&lang=ts&"
export * from "./messageList.vue?vue&type=script&lang=ts&"
import style0 from "./messageList.vue?vue&type=style&index=0&id=33a32f53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a32f53",
  null
  
)

export default component.exports